export default __webpack_public_path__ + "static/media/Informes generales.77a8c081.png";